/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import MainPageHeader from '../Components/MainPageHeader';
import DefineModel from './DefineModel/DefineModel';
import ISRTabs from '../Components/ISRTabs';
import { MODEL, RELATIONSHIPS, USER_INTERFACE, UI_MODEL } from '../ISRConstants';
import { TUpsertISRProjectDataModelsInput, TUpsertISRProjectDataModelsInput1 } from './DefineModel/model';
import { createProject, createUIMOdel, getISRProject, getUIModels } from './DefineModel/ModelServices/ModalServices';
import { toast } from 'react-toastify';
import _isEqual from 'lodash/isEqual';
import { useISRContext } from '../Hooks/useISRContext';
import { TUIModel } from './UIBuilder/ui';
import { AppContext } from 'Context/AppContext';
import { TUIBuilder } from './UIBuilder/ui';
import UIBuilder from './UIBuilder/UIBuilder';
import CreateISRDialog from "../Components/CreateISRDialog";
import RulesComponent from './Rules/Rules';
import { SB3RuleContextProvider } from '../Components/Rules/SB3RuleContext';
import { useLocation } from 'react-router-dom';
import { UIModelsModule } from '../UI-Model/UIModelsModule';

type TISRProjectProps = {
    isrId?: string;
    isrName?: string;
}

const ISRMainPage = ({isrId, isrName}: TISRProjectProps) => {
    const location = useLocation();
    const appContext = useContext(AppContext);
    const isrContext = useISRContext();
    const initialModels: TUpsertISRProjectDataModelsInput = { project: { ISRName:  "", dataModels: [], fields: [], productCategories: [], connectors: [], id: '' }, rules: [], };
    const [projectId, setProjectId] = useState<string | null | undefined>('');
    
    const [uiModelProjectData, setUiModelProjectData] = useState<TUIModel>({ channel: appContext?.channelKey, industry: isrContext?.industryId ?? '', projectId: '', orientation: 'Grid', id: ''} );
    const [uiBuilderProjectData, setUiBuilderProjectData] = useState<TUIBuilder>({ channel: appContext?.channelKey,industry: isrContext?.industryId ?? '', projectId: '', orientation: 'Grid', pages: [{pageName: 'New Page 1', formData: []}], id: '', config: {} });
    const initializeUIModel = { channel: appContext?.channelKey, industry: isrContext?.industryId ?? '', projectId: projectId, orientation: 'Grid', id: ''};
    const [userProjectDataModels, setUserProjectDataModels] = useState<TUpsertISRProjectDataModelsInput>(initialModels);
    const [isPreviewAvailable, setIsPreviewAvailable] = useState<boolean>(false)

    const [doesISRProjectAPICalled, setDoesISRProjectAPICalled] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<number>(0);
    const isGuideDetail = Boolean(location.pathname.includes('/guide/'));
    const tabLabels =  [MODEL, RELATIONSHIPS, USER_INTERFACE, UI_MODEL];

    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [showLoaderUi, setShowLoaderUi] = useState<boolean>(true);
    const [loaderMessage, setLoaderMessage] = useState<string>('');
    const [showDialog, setShowDialog] = useState<boolean>(false);

    const openDialog = () => setShowDialog(true);
    const closeDialog = () => setShowDialog(false);

    useEffect(() => { setProjectId(isrId);}, [isrId]);
    
    const handleTabClick = (index: number) => setActiveTab(index);

    const updateProjectDataModels = (
        setDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>,
        project: TUpsertISRProjectDataModelsInput
    ) => {
        setDataModels((prev: TUpsertISRProjectDataModelsInput) => {
            if (!project) {
                return prev;
            }
            return {
                ...prev,
                project: { ...prev.project, ...project },
            };
        });
    };

    useEffect(() => {
        if (appContext?.channelKey) {
            setUiModelProjectData((prevUiModel: any) => {
                return {
                    ...prevUiModel,
                    channel: appContext?.channelKey,
                    projectId: uiBuilderProjectData.projectId,
                    builderPages: {
                        pages: uiBuilderProjectData.pages,
                        config: uiBuilderProjectData.config
                    },
                };
            });
        }
    }, [uiBuilderProjectData, appContext?.channelKey]);

    useEffect(() => {
        let isMounted = true;
        const timerId = setTimeout(() => {
            if (isMounted) {
                if (doesISRProjectAPICalled) {
                    setDoesISRProjectAPICalled(false);
                    return;
                }
                // for sibin's refrence
                // const isEqual = _isEqual(isrContext?.networkUserProjectDataModels, userProjectDataModels);
                // if (isEqual) return;
                const haveChanges = _isEqual(isrContext?.networkUserProjectDataModels, isrContext?.initialUserProjectDataModels);
                if (!haveChanges) {
                    createISRProject();
                }
            }
        }, 1500);
        return () => {
            isMounted = false;
            clearTimeout(timerId);
        };
    }, [userProjectDataModels]);
    
    const createISRProject = async (isRuleUpdate: boolean = false) => {
        try {
            setShowLoader(true);
            setLoaderMessage('Saving changes...');
            const isrProject : TUpsertISRProjectDataModelsInput1 = {industry: isrContext?.industryId ?? '', channel: appContext?.channelKey, id: projectId ? projectId : isrId === "null" ? '' : isrId , project: userProjectDataModels.project, rules: []};
            const response = await createProject(isrProject, isGuideDetail);
            if (response === null) return;
            if (response?.done) {
                const { project_data  } = response;
                const project: TUpsertISRProjectDataModelsInput = project_data?.project;
                setProjectId( response?.project_data?.id ?? '');
                const areObjectsEqual = _isEqual(isrContext?.networkUserProjectDataModels.project, project);
                if (!areObjectsEqual) {
                    updateProjectDataModels(isrContext?.setNetworkUserProjectDataModels, project);
                    if (isrContext?.updateLocalState) {
                        updateProjectDataModels(setUserProjectDataModels, project);
                    }
                    if (isRuleUpdate) {
                        updateProjectDataModels(setUserProjectDataModels, project);
                    }
                }
            } else {
                toast.error(response?.message ?? '');
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            setShowLoader(false);
            isrContext?.setUpdateLocalState(false);
            setLoaderMessage('');
        }
    }

    useEffect(() => {
        let isMounted = true;
        const timerId = setTimeout(() => {
            if (isMounted) {
                if (uiModelProjectData.projectId === '') {
                    console.log('Project Id is missing ...');
                    return;
                }
                // if (uiModelProjectData?.pages[0]?.pageName === '') {
                //     console.log('A Page name is required');
                //     return;
                // }
                if (isrContext?.doesUIDefinitionAPICalled) {
                    isrContext?.setDoesUIDefinitionAPICalled(false);
                    return;
                }
                // if (uiModelProjectData?.pages[0]?.pageName === '') {
                //     console.log('A Page name is required');
                //     return;
                // }
                // if (isrContext?.doesUIDefinitionAPICalled) {
                //     isrContext?.setDoesUIDefinitionAPICalled(false);
                //     return;
                // }                
                createUIDefinition();
            }
        }, 5000);
        return () => {
            isMounted = false;
            clearTimeout(timerId);
        };
    }, [uiModelProjectData]);

    const createUIDefinition = async () => {
        try {
            setShowLoader(true);
            setLoaderMessage('Saving changes...');
            //console.log(uiModelProjectData)
            const response = await createUIMOdel(uiModelProjectData);
            if (response === null) return;
            if (response?.done) {
                const uiDefinition: TUIModel = response?.data;
                const areObjectsEqual = _isEqual(uiModelProjectData, response?.data);
                if (!areObjectsEqual) {
                    setUiModelProjectData(uiDefinition);
                    setIsPreviewAvailable(uiDefinition?.isPreviewAvailable ?? false)
                }
            } else {
                toast.error(response?.message ?? '');
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            setShowLoader(false);
            setLoaderMessage('');
        }
    }

    useEffect(() => {
        if (isrId ===  'null') return;
        setProjectId(isrId);
        fetchISRProjects();
    }, [isrContext?.industryId]);


    const fetchISRProjects = async () => {
        try {
            setDoesISRProjectAPICalled(true);
            setShowLoader(true);
            setLoaderMessage(`Fetching ${isrName} project ...`);
            const responseData = await getISRProject(isrId ?? '');
            if (responseData?.done) {
                const { data } = responseData;
                //console.log(data?.id)
                setProjectId(data?.id ?? '');
                setUserProjectDataModels(data ?? initialModels);
                isrContext?.setNetworkUserProjectDataModels(data ?? isrContext?.initialUserProjectDataModels);
                await fetchUIDefinitions(data);
            } else {
               // setUserProjectDataModels(initialUserProjectDataModels);
            }
        } catch (error) {
            console.error('Error fetching ISR projects:', error);
            setUserProjectDataModels(initialModels);
        } finally {
            setShowLoader(false);
            setLoaderMessage('');
        }
    }

    const handleEditName = (value: string) => {
        setUserProjectDataModels((prevConfig) => ({ ...prevConfig, project: {...prevConfig.project, ISRName: value}}));
        closeDialog();
    };

    const fetchUIDefinitions = async (data?: any) => {
        try {
            setShowLoaderUi(true);
            isrContext?.setDoesUIDefinitionAPICalled(true);
            const id = data?.id ?? '' //userProjectDataModels?.project?.id ?? '';
            if (id) {
                const responseData = await getUIModels(id ?? '');
                if (responseData?.done) {
                    setUiModelProjectData(responseData?.data ?? initializeUIModel);
                    setIsPreviewAvailable(responseData?.data?.isPreviewAvailable ?? false)
                }
            }

        } catch (error) {
            console.error('Error fetching UI Model', error);
           // setUserProjectDataModels(initialUserProjectDataModels);
        } finally {
            setShowLoaderUi(false);
        }
    }
    return (
        <React.Fragment>
            <MainPageHeader 
                componentId="isr-page-header"
                isrName={userProjectDataModels.project.ISRName ?? ''} 
                showLoader={showLoader} 
                loaderMessage={loaderMessage} 
                productId={projectId ? projectId : isrId === "null" ? '' : isrId} 
                id={projectId} 
                onEditClick={() => openDialog()} isGuideDetail={isGuideDetail}
            />
            <div id="isr-tabs-wrapper" className='tw-flex tw-justify-center tw-border-b tw-border-t tw-border-solid tw-border-lightgray-200'>
                <ISRTabs 
                    id="isr-tabs"
                    tabLabels={tabLabels} 
                    activeTab={activeTab} 
                    onTabClick={handleTabClick} 
                    showLoaderUi={showLoaderUi} 
                />
            </div>
            {activeTab === 0 ? 
                <DefineModel 
                    id="isr-define-model"
                    userProjectDataModels={userProjectDataModels} 
                    setUserProjectDataModels={setUserProjectDataModels} 
                    createISRProject={createISRProject}
                /> 
            : null}
            {activeTab === 1 ? 
                <SB3RuleContextProvider>
                    <RulesComponent id="isr-rules" projectId={projectId} /> 
                </SB3RuleContextProvider> 
            : null}
            {activeTab === 2 && !showLoaderUi ? 
                <UIBuilder 
                    id="isr-ui-builder"
                    isPreviewAvailable={isPreviewAvailable} 
                    userProjectDataModels={userProjectDataModels} 
                    builderData={uiModelProjectData} 
                    uiModelProjectData={uiBuilderProjectData} 
                    projectId={isrContext?.networkUserProjectDataModels?.id ?? ''} 
                    modelId={uiModelProjectData?.projectId ?? ''} 
                    setUiModelProjectData={setUiBuilderProjectData} 
                /> 
            : null}
            {activeTab === 3 ? 
            <UIModelsModule
                channelId={appContext?.channelKey}
                projectId={isrContext?.networkUserProjectDataModels?.id ?? ''}
                userId={isrContext?.networkUserProjectDataModels?.created_by ?? ''}
                userProjectDataModels={userProjectDataModels}
                industryId={isrContext?.industryId ?? ''} 
                selectedParty={appContext?.selectedParty}
            />
        : null}
            {showDialog ? 
                <CreateISRDialog
                    id="update-isr-model-name"
                    dialogHeader={'Edit Model Name'} 
                    labelName={'Model Name'} 
                    onClose={closeDialog} 
                    onSubmodelFieldSubmit={handleEditName} 
                    showCancelButton={false} 
                    actionLabel={'Save'}
                    value={userProjectDataModels.project.ISRName}  
                /> 
            : null}
            
        </React.Fragment>
    );
}

export default ISRMainPage;
